import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { Vendor } from 'app/core/model/vendor';
import { Utility } from 'app/core/utility';

@Component({
    standalone: false,
    selector: 'app-vendor-detail',
    templateUrl: './vendor-detail.component.html',
    styleUrl: './vendor-detail.component.scss',
})
export class VendorDetailComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    route = inject(ActivatedRoute);
    auth = inject(AuthService);
    router = inject(Router);
    location = inject(Location);
    appInfo = inject(AppInformationService);

    key: number | string;
    vendor: Vendor;
    states: string[];
    countries: string[];
    terms: any[];

    canDeactivate() {
        return !this.hasChanges();
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async ngOnInit() {
        this.terms = Utility.Terms;
        this.states = this.uow.lookups.states;
        this.countries = this.uow.lookups.countries;

        this.key = this.route.snapshot.params['id'];
        if (this.key === 'new') {
            this.vendor = this.uow.vendors.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                country: 'US',
            });
        } else {
            this.vendor = await this.uow.vendors.byId(this.key);
        }
    }

    async save() {
        this.appInfo.pleaseWaitShow();

        this.vendor.quickBooksLastExport = null;
        await this.uow.commit();
        if (this.key === 'new') {
            this.router.navigate(['../' + this.vendor.id], { relativeTo: this.route, replaceUrl: true, state: { navigateOnSaveNew: true } });
        }
        this.key = this.vendor.id;
        this.appInfo.pleaseWaitHide();
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }
}
